import React, { FC } from 'react';

type Props = {
    message: string;
}

const DesplaySmallMessage: FC<Props> = ({ message }) => {

    if (!message) return null;

    return (
        <div style={{ fontSize: '1rem', color: 'red' }}>{message}</div>
    );
}

export default DesplaySmallMessage;